import { createGetEndpoint } from '@sonar-software/sonar-http';
import { SonarTag } from '@types';

export type GetInitiativeTagsRequest = {
	initiativeId: number;
};

export type GetInitiativeTagsResponse = Array<SonarTag>;

export const getInitiativeTags = createGetEndpoint<GetInitiativeTagsRequest, GetInitiativeTagsResponse>(
	({ initiativeId }) => `/api/v3/initiatives/${initiativeId}/sonarobjects/tags`
);
